import Incidents from "./Incidents"
export default Incidents